import {RestRequestGET} from 'libs/RestRequest'
import Endpoints from 'constants/Endpoints'
import reduxStore from 'redux/store'
import {setResource} from 'redux/actions'
import moment from 'moment'

const profile = async () => {
	try {
		const res = await RestRequestGET(Endpoints.USER_PROFILE);
		reduxStore.dispatch(
			setResource('userProfile', res)
		)
	} catch (error) {
	}
}

const data = async () => {
	try {
		const res = await RestRequestGET(Endpoints.USER_DATA);
		reduxStore.dispatch(
			setResource('userData', res)
		)
		return res;
	} catch (error) {
	}

}

const sessionTime = async () => {
	try {
		const res = await RestRequestGET(Endpoints.USER_SESSION_TIME);
		const value = res.result;
		const endTime = moment().add(value,'s')
		reduxStore.dispatch(setResource('sessionTime', {
			time: value,
			endTime
		}))
	} catch (error) { }
}

const serverTime = async () => {
	const res = await RestRequestGET(Endpoints.USER_SERVER_TIME);
	return res.result
}

export default {
	data,
	profile,
	sessionTime,
	serverTime,
};

